<template>
  <component
    :is="tag"
    class="rounded-lg bg-white"
    :class="{ 'shadow-lg': elevated, border: outlined }"
  >
    <slot />
  </component>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    elevated?: boolean;
    outlined?: boolean;
    tag?: string;
  }>(),
  {
    elevated: false,
    outlined: false,
    tag: "div",
  },
);
</script>
